import React from 'react';
import { Input } from 'antd';

import LockIcon from '@assets/img/input-lock.svg';

function InputPassword(props) {
  return (
    <div className="input-password">
      <Input.Password {...props} prefix={<LockIcon width={14} height={18} />} />
    </div>
  );
}

export default InputPassword;
